/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var focusableSelector = 'input, select, textarea, button, object, a[href], [tabindex]';
var _default = function _default(node) {
  if (!node) {
    return null;
  }
  var nodes = (0, _toConsumableArray2.default)(node.querySelectorAll(focusableSelector));
  nodes = nodes.filter(function (el) {
    return !!el.offsetParent;
  });
  return nodes;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/getFocusableElements/index.js
// module id = 273
// module chunks = 0